import React from 'react';
import { Route, Switch } from 'react-router-dom';
import EditProduct from '../../../ProductEdit/index';

export default () => (
  <Switch>
    <Route exact path="/editProduct" component={EditProduct} />
  </Switch>
);
